module.exports = __webpack_public_path__ + "static/media/lilly.108a6a3f.svg";